'use client';
import clsx from 'clsx';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import styles from '@/components/BackButton/BackButton.module.scss';

declare global {
  interface Window {
    webkit?: { messageHandlers: { close: { postMessage: (msg: string) => void } } };
    Android?: { close: (msg: string) => void };
  }
}

interface BackButtonProps {
  type: 'text' | 'icon';
  text?: string;
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
}

export default function BackButton({ type, text, onClick, className, children }: Readonly<BackButtonProps>) {
  const router = useRouter();

  const handleClose = () => {
    onClick?.();
    if (globalThis.window?.webkit) {
      globalThis.window.webkit.messageHandlers.close.postMessage('');
    } else if (globalThis.window?.Android) {
      globalThis.window.Android.close('');
    } else {
      router.back();
    }
  };

  return (
    <button
      type="button"
      className={clsx(styles.backButton, type === 'text' ? styles.textBackButton : styles.iconBackButton, className)}
      onClick={handleClose}
    >
      {type === 'text' ? (
        <span className={styles.text}>{text}</span>
      ) : (
        <Image src="/cc/image/icon_leftArrow.svg" alt="뒤로가기" width={12} height={24} />
      )}
      {children}
    </button>
  );
}
